import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';

import { Prescription } from '../prescription';
import { PrescriptionTemplate } from '../../prescription-template/prescription-template';

declare var jQuery: any;

@Component({
  selector: 'mc-prescription-form',
  templateUrl: './prescription-form.component.html',
  styleUrls: ['./prescription-form.component.scss']
})
export class PrescriptionFormComponent implements OnInit {

  @ViewChild('editor', { static: true }) editor: QuillEditorComponent;
  @ViewChild('createNewModal', { static: true }) private createNewModal: ElementRef;
  @Input() prescription: Prescription;
  @Input() detached: boolean;
  @Output() canceled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saved: EventEmitter<Prescription> = new EventEmitter<Prescription>();
  @Output() printed: EventEmitter<Prescription> = new EventEmitter<Prescription>();

  constructor() { }

  ngOnInit() {
    if (!this.detached) { return; }
    if (!this.prescription) {
      this.prescription = new Prescription();
    }
  }

  save(): void {
    this.saved.emit(this.prescription);
  }

  cancel(): void {
    this.canceled.emit(true);
  }

  print(): void {
    this.printed.emit(this.prescription);
  }

  searchPrescriptionTemplate(): void {
    jQuery(this.createNewModal.nativeElement).modal('show');
  }

  selectedTemplate(template: PrescriptionTemplate): void {
    const quill = this.editor.quillEditor;
    const delta = quill.clipboard.convert(template.text + '<br/><br/>');
    const concatDelta = quill.getContents().concat(delta)
    quill.setContents(concatDelta, 'user');
  }
}
